import React from "react";
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import BlankLink from '../elements/BlankLink';

const className = 'link';

export default class Link extends React.PureComponent {
    render() {
        let { link, text, isInternal, onClick } = this.props;

        if (link.substr(0, 1) === '#') {
            return <HashLink className={className} to={link}>{text}</HashLink>
        }

        if (isInternal) {
            return <NavLink onClick={onClick} className={className} to={link}>{text}</NavLink>
        }

        return <BlankLink className={className} link={link} text={text}/>
    }
}

Link.propTypes = {
    onClick: PropTypes.func,
    link: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    isInternal: PropTypes.bool.isRequired,
};

